import { all, fork } from "@redux-saga/core/effects";
import { rootFlowsSaga } from "./flows";
import { rootUsersSaga } from "./users";
import { rootRolesSaga } from "./roles";
import { rootSubscriptionsSaga } from "./subscriptions";
import { rootCredentialManangementSaga } from "./credentialManagement";
import { rootCustomerBillingSaga } from "./customerBilling";
import { rootIntegrationsSaga } from "./integrations";
import { rootAuthSaga } from "./auth";
import { rootResourceDependenciesSaga } from "./resourceDependencies";

export default function* rootPortalSaga() {
  yield all([
    fork(rootFlowsSaga),
    fork(rootUsersSaga),
    fork(rootRolesSaga),
    fork(rootSubscriptionsSaga),
    fork(rootCredentialManangementSaga),
    fork(rootCustomerBillingSaga),
    fork(rootIntegrationsSaga),
    fork(rootAuthSaga),
    fork(rootResourceDependenciesSaga)
  ]);
}
